import { ElementRef, EventEmitter, SimpleChanges, } from '@angular/core';
import { COLOR_PICKER_OPTIONS_DEFAULT } from './color-picker.constant';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { DropdownHelperService } from 'NewAngular/services/dropdown-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "NewAngular/services/dropdown-helper.service";
import * as i3 from "@angular/common";
import * as i4 from "@angular/forms";
import * as i5 from "../../../directives/icon/icon.directive";
const _c0 = a0 => ({ show: a0 });
const _c1 = a0 => ({ "color": a0 });
const _c2 = a0 => ({ backgroundColor: a0 });
const _c3 = a0 => ({ current: a0 });
const _c4 = (a0, a1) => ({ current: a0, empty: a1 });
function ColorPickerComponent__svg_svg_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 13);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r1.iconToggle)("ngStyle", i0.ɵɵpureFunction1(2, _c1, ctx_r1.currentColor));
} }
function ColorPickerComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 14);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c2, ctx_r1.currentColor));
} }
function ColorPickerComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function ColorPickerComponent_div_7_Template_div_click_0_listener() { const color_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setColor(color_r4.value, 0, true)); });
    i0.ɵɵelement(1, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const color_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c3, ctx_r1.currentColor === color_r4.value));
    i0.ɵɵadvance();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(5, _c2, color_r4.value));
} }
function ColorPickerComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵlistener("click", function ColorPickerComponent_div_16_Template_div_click_0_listener() { const color_r7 = i0.ɵɵrestoreView(_r6).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(color_r7 !== "transparent" && ctx_r1.setColor(color_r7, 0, true)); });
    i0.ɵɵelement(1, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const color_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c4, ctx_r1.currentColor === color_r7, color_r7 === "transparent"));
    i0.ɵɵadvance();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(6, _c2, color_r7));
} }
/**
 * Color Picker Component
 *
 * A clickable dropdown that allows users to select from default colors or their client group's custom colors.
 *
 * Inputs:
 *   useCustomColors: A boolean describing whether or not to use client group custom colors.
 *   dropdownClass: custom classnames to add to the root element in this component.
 *   dropdownMenuClass: custom class names to add to the dropdown menu container element.
 *   buttonClass: custom classnames to add to the dropdown toggle button.
 *   iconToggle: icon name to use as the dropdown toggle.
 *   currentColor: Hex color string for the color that should be initially selected.
 *
 * Outputs:
 *   setColorHandler: An event emitter than emits the selected color string when a color is selected from the dropdown.
 *
 * Usage:
 *   From the parent component: this.colorPickerComponent.setColor().
 *   A function is used instead of an input/two-way bindings to prevent Angular change detection errors.
 */
export class ColorPickerComponent {
    constructor(accountsService, dropdownHelperService, el) {
        this.accountsService = accountsService;
        this.dropdownHelperService = dropdownHelperService;
        this.el = el;
        this.useCustomColors = false;
        this.currentColor = '';
        this.setColorHandler = new EventEmitter();
        this.colorOptions = COLOR_PICKER_OPTIONS_DEFAULT;
        this.recentColors = [];
        this.showColorDropdown = false;
        this.useDefaultColor = true;
    }
    ngOnInit() {
        this.accountsService.getUserPreferences().subscribe(({ recent_colors }) => {
            this.recentColors = this.mergeRecentColors(recent_colors);
        });
    }
    ngAfterViewInit() {
        const autoCloseHandler = () => {
            if (this.showColorDropdown) {
                this.showColorDropdown = false;
            }
        };
        this.dropdownHelperService.setCloseHandler(this.el.nativeElement, autoCloseHandler);
    }
    mergeRecentColors(newRecentColors = []) {
        const defaultRecentColors = Array(5).fill('transparent');
        return [...newRecentColors, ...defaultRecentColors].slice(0, 5);
    }
    ngOnChanges(changes) {
        if (changes.currentColor?.currentValue) {
            this.useDefaultColor = !this.currentColor;
        }
        if (changes?.useCustomColors) {
            if (changes.useCustomColors.currentValue) {
                this.accountsService
                    .getClientGroupPreferences()
                    .subscribe((clientGroupPreference) => {
                    // Because hex color strings can contain either capital or lowercase letters
                    // make all letters lowercase for correct equality comparison.
                    // This is necessary to show which color is "current"ly selected in the template.
                    this.colorOptions = Object.entries(clientGroupPreference.primary_colors).map((keyValPair) => keyValPair[1].toLowerCase());
                });
            }
            else {
                this.colorOptions = COLOR_PICKER_OPTIONS_DEFAULT;
            }
        }
    }
    /**
     * Handle button clicks for the color picker dropdown.
     */
    toggleDropdown(showColorDropdown) {
        if (showColorDropdown !== undefined) {
            this.showColorDropdown = showColorDropdown;
        }
        else {
            this.showColorDropdown = !this.showColorDropdown;
        }
    }
    /**
     * Set the selected color. If newColor is empty, we assume the default color is used.
     * @param newColor: Hex color string i.e. '#fff000'
     * @param index: The list position of the color picker's item.
     * @param pushToRecent: If it's a new selected color it should be pushed to recent colors.
     */
    setColor(newColor = '', index = 0, pushToRecent = false) {
        if (!newColor) {
            this.currentColor = this.colorOptions[index % Object.keys(this.colorOptions).length];
            this.useDefaultColor = true;
        }
        else {
            this.currentColor = newColor;
            this.useDefaultColor = false;
            if (pushToRecent) {
                this.pushRecentColor(newColor);
            }
        }
        this.setColorHandler.emit(this.currentColor);
        this.toggleDropdown(false);
    }
    /**
     * After setting the color push it to recent_colors
     * @param newColor: Hex color string i.e. '#fff000'
     */
    pushRecentColor(newColor = '') {
        const newRecentColors = [
            newColor,
            ...this.recentColors
                .filter((color) => color !== newColor) // Avoid duplicate colors
                .splice(0, 4), // Evict the last one out if needed
        ];
        this.accountsService.putUserPreferences({ recent_colors: newRecentColors }).subscribe(() => {
            this.recentColors = this.mergeRecentColors(newRecentColors);
        });
    }
    getDefaultColorForIndex(index) {
        return this.colorOptions[index];
    }
}
ColorPickerComponent.ɵfac = function ColorPickerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ColorPickerComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.DropdownHelperService), i0.ɵɵdirectiveInject(i0.ElementRef)); };
ColorPickerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ColorPickerComponent, selectors: [["ycn-color-picker"]], inputs: { useCustomColors: "useCustomColors", dropdownClass: "dropdownClass", dropdownMenuClass: "dropdownMenuClass", buttonClass: "buttonClass", iconToggle: "iconToggle", currentColor: "currentColor" }, outputs: { setColorHandler: "setColorHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 17, vars: 19, consts: [["defaultToggle", ""], ["colorPicker", ""], [1, "dropdown"], ["href", "javascript:void(0)", "role", "button", 3, "click"], ["ycnIcon", "", "class", "fill-current", 3, "name", "ngStyle", 4, "ngIf", "ngIfElse"], [3, "ngClass"], [1, "row"], ["class", "col-4", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "col-12"], [1, "col-4", 3, "click"], [1, "dropdown-color", "btn-secondary"], ["ycnIcon", "", 3, "name"], ["type", "color", 1, "hidden", "pointer-events-none", 3, "change", "ngModelChange", "ngModel"], ["ycnIcon", "", 1, "fill-current", 3, "name", "ngStyle"], [1, "dropdown-color", 3, "ngStyle"], [1, "col-4", 3, "click", "ngClass"], [1, "dropdown-color"], [1, "dropdown-color", "dropdown-color-action"]], template: function ColorPickerComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "a", 3);
        i0.ɵɵlistener("click", function ColorPickerComponent_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggleDropdown()); });
        i0.ɵɵtemplate(2, ColorPickerComponent__svg_svg_2_Template, 1, 4, "svg", 4)(3, ColorPickerComponent_ng_template_3_Template, 1, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "span", 5)(6, "div", 6);
        i0.ɵɵtemplate(7, ColorPickerComponent_div_7_Template, 2, 7, "div", 7);
        i0.ɵɵpipe(8, "keyvalue");
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵtext(10, "Recent");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 9);
        i0.ɵɵlistener("click", function ColorPickerComponent_Template_div_click_11_listener() { i0.ɵɵrestoreView(_r1); const colorPicker_r5 = i0.ɵɵreference(15); return i0.ɵɵresetView(colorPicker_r5.click()); });
        i0.ɵɵelementStart(12, "div", 10);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(13, "svg", 11);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(14, "input", 12, 1);
        i0.ɵɵlistener("change", function ColorPickerComponent_Template_input_change_14_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setColor(ctx.currentColor, 0, true)); });
        i0.ɵɵtwoWayListener("ngModelChange", function ColorPickerComponent_Template_input_ngModelChange_14_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.currentColor, $event) || (ctx.currentColor = $event); return i0.ɵɵresetView($event); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(16, ColorPickerComponent_div_16_Template, 2, 8, "div", 7);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        const defaultToggle_r8 = i0.ɵɵreference(4);
        i0.ɵɵclassMap(ctx.dropdownClass);
        i0.ɵɵadvance();
        i0.ɵɵclassMap(i0.ɵɵinterpolate1("btn btn-secondary dropdown-toggle ", ctx.buttonClass));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.iconToggle)("ngIfElse", defaultToggle_r8);
        i0.ɵɵadvance(3);
        i0.ɵɵclassMap(i0.ɵɵinterpolate1("dropdown-menu dropdown-colors ", ctx.dropdownMenuClass));
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c0, ctx.showColorDropdown));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(8, 15, ctx.colorOptions));
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("name", "icon-add");
        i0.ɵɵadvance();
        i0.ɵɵtwoWayProperty("ngModel", ctx.currentColor);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.recentColors);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgStyle, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i5.IconDirective, i3.KeyValuePipe], encapsulation: 2 });
